import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { translate } from 'helpers/translateHelper';
import { SingleDateSelector } from 'sharedComponents';
import moment from 'moment';
import TrendCommentsModalFieldError from './TrendCommentsModalFieldError';

const TrendCommentsModalDateTimeSection = ({ formData, errors, handleChange, datePickerVisibility, minDate, maxDate }) => {
    return (
        <Row className='date-time-section'>
            <Col>
                <label>
                    {translate('ABB.Powertrain.Frontend.opTrendCommentsModalDateLabel')}
                </label>
                <SingleDateSelector
                    className={`date-time-input ${errors.date ? 'error' : ''}`}
                    value={formData.date}
                    onSelect={(value) => value && handleChange('date', moment(value).format('YYYY-MM-DD'))}
                    visibilityControl={datePickerVisibility}
                    numberOfMonths={1}
                    minDate={minDate}
                    maxDate={maxDate}
                    placeholder={translate('ABB.Powertrain.Frontend.opTrendCommentsModalDateFormat')}
                    confirmOnSelect={true}
                    showLeftIcon={false}
                    showRightIcon={true}
                    disableFuture={true}
                    placement='left'
                />
                <TrendCommentsModalFieldError message={errors.date} withIcon />
            </Col>
            <Col>
                <label>
                    {translate('ABB.Powertrain.Frontend.opTrendCommentsModalTimeLabel')}
                </label>
                <input
                    type='time'
                    className={`date-time-input ${errors.time ? 'error' : ''}`}
                    value={formData.time}
                    step='1'
                    onChange={(e) => handleChange('time', e.target.value)}
                    placeholder={translate('ABB.Powertrain.Frontend.opTrendCommentsModalTimeFormat')}
                />
                <TrendCommentsModalFieldError message={errors.time} withIcon />
            </Col>
        </Row>
    );
};

TrendCommentsModalDateTimeSection.propTypes = {
    formData: PropTypes.object,
    errors: PropTypes.object,
    handleChange: PropTypes.func,
    datePickerVisibility: PropTypes.object,
    minDate: PropTypes.string,
    maxDate: PropTypes.string
};

export default TrendCommentsModalDateTimeSection;
